import { Component, Input, OnInit } from '@angular/core';
import { AnnualFrequencyEnum } from 'taxtank-core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@shared/material/material.module';
import { AbstractControlComponent } from '@shared/component/form-controls/abstract-control/abstract-control.component';

@Component({
  selector: 'app-frequency-select',
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    RxReactiveFormsModule
  ],
  templateUrl: './frequency-select.component.html',
  styleUrl: './frequency-select.component.scss'
})
export class FrequencySelectComponent extends AbstractControlComponent<number> implements OnInit {
  protected readonly frequencyList = AnnualFrequencyEnum;
  options: AnnualFrequencyEnum[];
  @Input() placeholder = 'Don\'t Repeat';
  @Input() exclude: AnnualFrequencyEnum[] = [AnnualFrequencyEnum.DAILY];

  ngOnInit(): void {
    super.ngOnInit();

    this.options = [
      AnnualFrequencyEnum.DAILY,
      AnnualFrequencyEnum.WEEKLY,
      AnnualFrequencyEnum.FORTNIGHTLY,
      AnnualFrequencyEnum.MONTHLY,
      AnnualFrequencyEnum.QUARTERLY,
      AnnualFrequencyEnum.ANNUAL,
    ].filter(frequency => !this.exclude.includes(frequency));
  }
}
